import styled from 'styled-components';
import { DatePicker, Form, InputNumber } from 'antd';

import { PitstopModal } from 'shared';

export const StyledPitstopModal = styled(PitstopModal)`
  && {
    .ant-modal-header {
      border-radius: 10px 10px 0 0;

      .ant-modal-title {
        color: #02103d;
      }
    }

    .ant-modal-content {
      border-radius: 10px;
    }

    .ant-modal-close-x {
      color: #02103d;
    }
  }
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 5px;
  width: 100%;
`;
export const StyledInputNumber = styled(InputNumber)`
  width: 100% !important;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100% !important;
`;

export const cancelButtonProps = {
  type: 'danger',
  ghost: true,
  style: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#ff4d4f',
    boxShadow: 'none',
  },
};
